var Tiers = require("lib/games/Tiers");
var Glyphicon = require("components/utility/icons/Glyphicon");
var ReactTooltip = require("react-tooltip");

require("games/tier_requirements_display.scss");

class TierRequirementsDisplay extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			itemOffset: 0
		};
	}

	getThumbnailPatchPath(patchType, patchName) {
		var patchPath = "patches/" + patchType + "/" + patchName + "-s.png";
		return dynamicRequire(patchPath);
	}
	getThumbnailPerkPath(perk) {
		if (perk.perk_type == "backgrounds" || perk.perk_type == "houses" || perk.perk_type == "owl_hoots" 
			|| perk.perk_type == "background_sounds" || perk.perk_type == "greetings") {
			
			if (perk.perk_type == "houses") {
				var name = perk.name.toLowerCase().replace(/ /g, '-');
				if (name.indexOf('\'') >= 0) {
					name = name.replace('\'', "");
				}
			} else {
				var name = perk.name.toLowerCase().replace(/\s/g, "_")
			}
			var perkPath = "perks/" + perk.perk_type + "/" + name + ".png";
			return dynamicRequire(perkPath);
		} else if (perk.perk_type == "titles") {
			return require("owl-item-types/titles.png");
		}
	}
	getThumbnailFurniturePath(furniture) {
		var perkPath = "perks/" + furniture.perk_type + "/" + furniture.name + ".png";
		return dynamicRequire(perkPath);
	}
	getPatchTypeName(patchType, tier) {
		var levelPrefix = "Level " + (parseInt(tier) + 1) + " ";
		if (patchType == "beak") {
			return levelPrefix + "Beak";

		} else if (patchType == "body") {
			return levelPrefix + "Body";

		} else if (patchType == "face") {
			return levelPrefix + "Face";

		} else if (patchType == "feet") {
			return levelPrefix + "Feet";

		} else if (patchType == "hand") {
			return levelPrefix + "Wings";

		} else if (patchType == "head") {
			return levelPrefix + "Head";

		} else {
			return "";
		}
	}
	getPerkTypeName(perkType, tier) {
		var levelPrefix = "Level " + (parseInt(tier) + 1) + " ";
		if (perkType == "houses") {
			return levelPrefix + "House";

		} else if (perkType == "total") {
			return "Any " + levelPrefix + "Perk";

		} else if (perkType == "titles") {
			return levelPrefix + "Title";

		} else if (perkType == "backgrounds") {
			return levelPrefix + "Wallpaper";

		} else if (perkType == "background_sounds") {
			return levelPrefix + "Tune";

		} else if (perkType == "owl_hoots") {
			return levelPrefix + "Hoot";

		} else if (perkType == "greetings") {
			return levelPrefix + "Greeting";

		} else {
			return "";
		}
	}
	getFurnitureTypeName(furnitureType, tier) {
		var levelPrefix = "Level " + (parseInt(tier) + 1) + " ";
		if (furnitureType == "sofas") {
			return levelPrefix + "Sofa";
		} else if (furnitureType == "total") {
			return "Any " + levelPrefix + "Furniture";

		} else if (furnitureType == "bookshelves") {
			return levelPrefix + "Bookshelf";

		} else if (furnitureType == "wall_items") {
			return levelPrefix + "Wall Item";
		} else if (furnitureType == "floor_items") {
			return levelPrefix + "Floor Item";
		} else {
			return "";
		}
	}
	isTypeFurniture(furnitureType) {
		if (["floor_items","wall_items","bookshelves","sofas"].indexOf(furnitureType) > -1) {
			return true
		}
		return false
	}
	shiftLeft() {
		this.setState({ itemOffset: this.state.itemOffset - this.props.maxSquares })			
	}
	shiftRight() {
		this.setState({ itemOffset: this.state.itemOffset + this.props.maxSquares })			
	}

	// gets the type of item from the tier reqs square
	onSquareClick(category, type) {
		if (this.props.toggleCategory) {
			if (typeof category =="string") {
				this.props.toggleCategory(category, type)
				this.props.beginAtTier(true)
			// toggles trophy room if req already met
			} else {
			this.props.toggleRoom("trophy")
			}
		}
	}

	render() {
		var currentTier = this.props.tier
		var userCoins = this.props.coins
		var reqPatchSquares = [];
		var reqPerkSquares = [];
		var reqFurnitureSquares = [];
		var otherItemSquares = [];
		var tierColor = Tiers.getColor(this.props.tier);

		_.map(this.props.requirements.patches, function(numPatchesReq, key) {
			var patchType = key == "hand" ? "left_hand" : key;
			var patchReqPath = dynamicRequire("owl-item-types/" + patchType + ".png");
			var ownedPatchesOfType = _.select(this.props.ownedPatches, function(patch) {
				//purposely exludes left handed items so only right hand patch appears
				//on display
				return (patch.patch_type == patchType) && patch.tier == this.props.tier;
			}.bind(this));

			_.times(numPatchesReq, function(i) {
				if (ownedPatchesOfType[i]) {
					var patchPath = this.getThumbnailPatchPath(key, ownedPatchesOfType[i].name);
					reqPatchSquares.push(
						<div className="reqMetSquare" onClick={this.onSquareClick} key={ "tier" + this.props.tier + key + i } 
							style={ { backgroundColor: tierColor, borderColor: tierColor } }
							data-tip={ ownedPatchesOfType[i].title }>
							<img src={ patchPath } className="itemImage" />
							<ReactTooltip effect="solid" />
						</div>
					);
				} else {
					var patchReqTooltipText = this.getPatchTypeName(key, this.props.tier);
					//if user can afford tier req, creates a square highlighted in their tier color
					if ($wr.canAffordItem(userCoins, currentTier, this.props.filteredPatches, "patch", key).length > 0) {
						reqPatchSquares.push(
							<div className="canAffordSquare" onClick={() =>this.onSquareClick("patch", patchType)} key={ "tier" + this.props.tier + key + i }
								style={{ borderColor: tierColor} }
								data-tip={ patchReqTooltipText }>
								<img src={ patchReqPath } className="itemImage" />
							</div>
						);
					} else {
						reqPatchSquares.push(
							<div className="reqNotMetSquare" onClick={() =>this.onSquareClick("patch", patchType)} key={ "tier" + this.props.tier + key + i }
								data-tip={ patchReqTooltipText }>
								<img src={ patchReqPath } className="itemImage" />
							</div>
						);
					}
				}
			}.bind(this));

			if (this.props.displayAllItems && ownedPatchesOfType.length > numPatchesReq) {
				for (var j = numPatchesReq; j < ownedPatchesOfType.length; j++) {
					var patchPath = this.getThumbnailPatchPath(key, ownedPatchesOfType[j].name);
					otherItemSquares.push(
						<div className="otherSquare" key={ "tier" + this.props.tier + key + j }
							data-tip={ ownedPatchesOfType[j].title }>
							<img src={ patchPath } className="itemImage" />
						</div>
					);
				};
			}
		}.bind(this));

		_.map(this.props.requirements.perks, function(numPerksReq, key) {
			if (key == "total") {
				var perkReqPath1 = require("owl-item-types/backgrounds.png");
				var perkReqPath2 = require("owl-item-types/owl_hoots.png");
				var perkReqPath3 = require("owl-item-types/background_sounds.png");
				var perkReqPath4 = require("owl-item-types/houses.png");
				var perkReqImg = (
					<div className="perkMiniItemDisplay">
						<img src={ perkReqPath1 } className="miniItemImage" />
						<img src={ perkReqPath2 } className="miniItemImage" />
						<img src={ perkReqPath3 } className="miniItemImage" />
						<img src={ perkReqPath4 } className="miniItemImage" />
					</div>
				);
				var ownedPerksOfType = _.select(this.props.ownedPerks, function(perk) {
					return perk.tier == this.props.tier;
				}.bind(this));
			} else {
				var perkReqPath = dynamicRequire("owl-item-types/" + key + ".png");
				var perkReqImg = (
					<img src={ perkReqPath } className="itemImage" />
				);
				var ownedPerksOfType = _.select(this.props.ownedPerks, function(perk) {
					return perk.perk_type == key && perk.tier == this.props.tier;
				}.bind(this));
			}

			_.times(numPerksReq, function(i) {
				if (ownedPerksOfType[i]) {
					var perkPath = this.getThumbnailPerkPath(ownedPerksOfType[i]);
					reqPerkSquares.push(
						<div className="reqMetSquare" onClick={this.onSquareClick} key={ "tier" + this.props.tier + key + i } 
							style={ { backgroundColor: tierColor, borderColor: tierColor } }
							data-tip={ ownedPerksOfType[i].name }>
							<img src={ perkPath } className="itemImage" />
							<ReactTooltip effect="solid" />
						</div>
					);
				} else {
					var perkReqTooltipText = this.getPerkTypeName(key, this.props.tier);

					if ($wr.canAffordItem(userCoins, currentTier, this.props.filteredPerks, "perk", key).length > 0) {
						reqPerkSquares.push(
							<div className="canAffordSquare" onClick={() =>this.onSquareClick("perk", key)} key={ "tier" + this.props.tier + key + i }
								style={{ borderColor: tierColor} }
								data-tip={ perkReqTooltipText }>
								{ perkReqImg }
							</div>
						);
					} else {
						reqPerkSquares.push(
							<div className="reqNotMetSquare"  onClick={() => this.onSquareClick("perk", key)} key={ "tier" + this.props.tier + key + i }
								data-tip={ perkReqTooltipText }>
								{ perkReqImg }
								<ReactTooltip effect="solid" />
							</div>
						);
					}
				}
			}.bind(this));

			if (this.props.displayAllItems && ownedPerksOfType.length > numPerksReq) {
				for (var j = numPerksReq; j < ownedPerksOfType.length; j++) {
					var perkPath = this.getThumbnailPerkPath(ownedPerksOfType[j]);
					otherItemSquares.push(
						<div className="otherSquare" 
							key={ "tier" + this.props.tier + ownedPerksOfType[j].perk_type + j }
							data-tip={ ownedPerksOfType[j].name }>
							<img src={ perkPath } className="itemImage" />
						</div>
					);
				};
			}
		}.bind(this));

		_.map(this.props.requirements.furnitures, function(numFurnituresReq, key) {
			if (key == "total") {
				var furnitureReqPath1 = require("owl-item-types/sofas.png");
				var furnitureReqPath2 = require("owl-item-types/bookshelves.png");
				var furnitureReqPath3 = require("owl-item-types/wall_items.png");
				var furnitureReqImg = (
					<div className="perkMiniItemDisplay">
						<img src={ furnitureReqPath1 } className="miniItemImage" />
						<img src={ furnitureReqPath2 } className="miniItemImage" />
						<img src={ furnitureReqPath3 } className="miniItemImage" />
					</div>
				);
				var ownedFurnituresOfType = _.select(this.props.ownedFurnitures, function(perk) {
					return perk.tier == this.props.tier;
				}.bind(this));
			} else {
				var furnitureReqPath = dynamicRequire("owl-item-types/" + key + ".png");
				var furnitureReqImg = (
					<img src={ furnitureReqPath } className="itemImage" />
				);
				var ownedFurnituresOfType = _.select(this.props.ownedFurnitures, function(perk) {
					return perk.perk_type == key && perk.tier == this.props.tier;
				}.bind(this));
			}

			_.times(numFurnituresReq, function(i) {
				if (ownedFurnituresOfType[i]) {
					var furniturePath = this.getThumbnailFurniturePath(ownedFurnituresOfType[i]);
					reqFurnitureSquares.push(
						<div className="reqMetSquare" onClick={this.onSquareClick} key={ "tier" + this.props.tier + key + i } 
							style={ { backgroundColor: tierColor, borderColor: tierColor } }
							data-tip={ ownedFurnituresOfType[i].title }>
							<img src={ furniturePath } className="itemImage" />
							<ReactTooltip effect="solid" />
						</div>
					);
				} else {
					var furnitureReqTooltipText = this.getFurnitureTypeName(key, this.props.tier);
					if ($wr.canAffordItem(userCoins, currentTier, this.props.allFurnitures, "furniture", key).length > 0) {
						reqFurnitureSquares.push(
							<div className="canAffordSquare" onClick={() => this.onSquareClick("furniture", key)} key={ "tier" + this.props.tier + key + i }
								style={{ borderColor: tierColor} }
								data-tip={ furnitureReqTooltipText }>
								{ furnitureReqImg }
							</div>
						);
					} else {
						//var furnitureReqTooltipText = this.getFurnitureTypeName(key, this.props.tier);
						reqFurnitureSquares.push(
						<div className="reqNotMetSquare" onClick={() => this.onSquareClick("furniture", key)} key={ "tier" + this.props.tier + key + i }
							data-tip={ furnitureReqTooltipText }>
							{ furnitureReqImg }
							<ReactTooltip effect="solid" />
						</div>
						);
					}
				}
			}.bind(this));

			if (this.props.displayAllItems && ownedFurnituresOfType.length > numFurnituresReq) {
				for (var j = numFurnituresReq; j < ownedFurnituresOfType.length; j++) {
					var furniturePath = this.getThumbnailFurniturePath(ownedFurnituresOfType[j]);
					otherItemSquares.push(
						<div className="otherSquare" 
							key={ "tier" + this.props.tier + ownedFurnituresOfType[j].perk_type + j }
							data-tip={ ownedFurnituresOfType[j].name }>
							<img src={ furniturePath } className="itemImage" />
						</div>
					);
				};
			}
		}.bind(this));

		var allSquares = reqPatchSquares.concat(reqPerkSquares, reqFurnitureSquares, otherItemSquares);
		if (this.props.maxSquares && allSquares.length > this.props.maxSquares) {
			var maxSquareIndex = this.state.itemOffset + this.props.maxSquares;
			var canShiftLeft = this.state.itemOffset > 0;
			var canShiftRight = allSquares.length >= maxSquareIndex;
			if (canShiftLeft) {
				var arrowLeft = (
					<button className="btn btn-link arrowLink arrowLeft" disabled={ !canShiftLeft }
						onClick={ this.shiftLeft }>
						<Glyphicon icon="arrow-left" />
					</button>
				);
			}
			if (canShiftRight) {
				var arrowRight = (
					<button className="btn btn-link arrowLink arrowRight" disabled={ !canShiftRight }
						onClick={ this.shiftRight }>
						<Glyphicon icon="arrow-right" />
					</button>
				);
			}
			var currentSquares = allSquares.slice(this.state.itemOffset, maxSquareIndex);
			return (
				<div className="tierRequirementsDisplay">
					{ arrowLeft }
					{ currentSquares }
					{ arrowRight }
					<ReactTooltip effect="solid" />
				</div>
			);
		} else {
			return (
				<div className="tierRequirementsDisplay">
					{ allSquares }
					<ReactTooltip effect="solid" />
				</div>
			);
		}
	}
}

TierRequirementsDisplay.propTypes = StrictPropTypes({
	// requirements for the tier
	requirements: PropTypes.object.isRequired,
	// tier
	tier: PropTypes.string.isRequired,
	// patches owned by user
	ownedPatches: PropTypes.array.isRequired,
	// perks owned by user
	ownedPerks: PropTypes.array.isRequired,
	// furnitures owned by user
	ownedFurnitures: PropTypes.array.isRequired,

	// option to display all owned items, not limited to items that meet requirements
	displayAllItems: PropTypes.bool,

	// option to specify the maximum number of squares on screen
	maxSquares: PropTypes.number,
	toggleRoom: PropTypes.func,
	toggleCategory: PropTypes.func,
	beginAtTier: PropTypes.func,

	filteredPatches: PropTypes.array,
	filteredPerks: PropTypes.array,
	allFurnitures: PropTypes.array,
	coins: PropTypes.number
});

module.exports = TierRequirementsDisplay;


// WEBPACK FOOTER //
// ./modules/components/games/TierRequirementsDisplay.js